import { z } from 'zod';
import { localeSchema } from './content.js';
/**
 * What the server injects into <head> before the browser (or a crawler)
 * sees the page.
 *
 * Facebook, Instagram, TikTok and WhatsApp link-preview crawlers do NOT run
 * JavaScript. Without this, every link Diana posts on social renders as a
 * blank grey card. See docs/04-ARCHITECTURE.md §7.
 */
export const pageMetaSchema = z.object({
    title: z.string(),
    description: z.string(),
    ogImage: z.string().nullable(),
    locale: localeSchema,
    canonical: z.string(),
    /** hreflang alternates — one per site language, plus x-default. */
    alternates: z.array(z.object({ lang: z.string(), href: z.string() })).default([]),
});
